export default "__VITE_ASSET__2d43ac15__"